<script setup lang="ts">
/**
 * Badge de statut d'un ticket de remplacement : icône Heroicon outline + couleur
 * + label (jamais la couleur seule, cf. MASTER §1). Réutilisé en liste compacte
 * et partout où l'on affiche un statut de remplacement.
 */
import { computed } from 'vue'
import {
  ArrowPathIcon,
  ArrowUturnLeftIcon,
  CheckBadgeIcon,
  CheckCircleIcon,
  ClipboardDocumentListIcon,
  InboxArrowDownIcon,
  ShoppingCartIcon,
  XCircleIcon,
} from '@heroicons/vue/24/outline'
import { REPLACEMENT_STATUS_META } from '@/v2/onboarding/catalog'
import type { ReplacementStatus } from '@/v2/onboarding/types'

const props = defineProps<{ status: ReplacementStatus; size?: 'sm' | 'md' }>()

const ICONS = {
  ClipboardDocumentList: ClipboardDocumentListIcon,
  ShoppingCart: ShoppingCartIcon,
  InboxArrowDown: InboxArrowDownIcon,
  ArrowUturnLeft: ArrowUturnLeftIcon,
  CheckCircle: CheckCircleIcon,
  CheckBadge: CheckBadgeIcon,
  XCircle: XCircleIcon,
  ArrowPath: ArrowPathIcon,
} as const

const meta = computed(() => REPLACEMENT_STATUS_META[props.status])
const icon = computed(() => ICONS[meta.value.icon as keyof typeof ICONS] ?? ArrowPathIcon)
const iconSize = computed(() => (props.size === 'md' ? 'h-4 w-4' : 'h-3.5 w-3.5'))
</script>

<template>
  <span :class="['badge gap-1', meta.badgeClass, size === 'md' ? 'badge-md' : 'badge-sm']">
    <component :is="icon" :class="iconSize" aria-hidden="true" />
    <span>{{ meta.label }}</span>
  </span>
</template>
